<template>
  <div class="page_content">

    <form name="form" id="uploadProgramGuideZipForm" method="POST" enctype="multipart/form-data" v-on:submit.prevent>

        <div class="hidden-container">
            <input type="file" id="uploadProgramGuideZipFile" name="file" ref="fileInput" @change="fileToBeUploaded" />
        </div>
        <div class="row page-heading mx-0">
            <div class="col-7 input module_heading" role="heading" aria-level="1">
              <span class="module_icon icon-list"></span>
              <span class="module_type_name">Program Guide Bulk Upload</span>
           </div>
            <div class="col-5 submit btn-container text-right">
                <button type="button" class="btn btn-primary" @click.prevent="cancel" aria-label="cancel">cancel</button>
                <button type="button" class="btn btn-primary" @click.prevent="upload" aria-label="upload" :disabled="!file">upload</button>
            </div>
        </div>
        <div>
            <b-row class="mt-5 upload-asset-section">
                <b-col cols="12" class="upload-asset-thru-csv pl-3 pr-3">
                    <div class="card">
                        <div class="heading">Upload Program Guides Via a Zip File</div>
                        <div class="thumbnail-section">
                            <span style="font-size: 115px;">
                              <i class="fas fa-file-archive"></i>
                            </span>
                        </div>
                        <div class="card-body text-center">
                            <template v-if="file">
                                <span style="margin-top: -15px;">Chosen File: <strong>{{ file.name }}</strong></span>
                                <button type="button" class="btn btn-primary" @click.stop="chooseFile" aria-label="Change Program Guide Zip File" style="bottom: 40px !important;">Change Program Guide Zip File</button>
                            </template>
                            <template v-else>
                                <button type="button" class="btn btn-primary" @click.stop="chooseFile" aria-label="Choose Program Guide Zip File">Choose Program Guide Zip File</button>
                            </template>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>

        <div class="loading-spinner">
          <b-modal style="padding: 0px; overflow: hidden;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
            <div class="text-center" style="color: #FFF; overflow: hidden;">
              <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
            </div>
          </b-modal>
        </div>

    </form>

  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  var isZipFile = function (file) {
    var fileName = file.name
    var regEx = /(.zip)$/i
    return regEx.test(fileName)
  }

  export default {
    name: 'program-guide-bulk-upload',
    data () {
      return {
        file: undefined
      }
    },

    methods: {
      ...mapActions([
        'bulkUploadProgramGuide'
      ]),

      cancel () {
        return this.$router.push({name: 'programGuideList'})
      },

      chooseFile () {
        let sel = 'id=uploadProgramGuideZipFile'
        $('input[type=file][' + sel + ']').click()
      },

      fileToBeUploaded (ev) {
        let files = ev.target.files || ev.dataTransfer.files
        if (!files.length) {
          return
        }
        this.file = files[0]
      },

      upload () {
        if (isZipFile(this.file)) {
          this.$refs.loadingModal.show()
          let data = new FormData()
          data.append($('#uploadProgramGuideZipFile').attr('name'), this.file, this.file.name)
          this.bulkUploadProgramGuide({fileData: data}).then(resp => {
            this.$refs.loadingModal.hide()
            return this.$router.push({ name: 'taskMonitor', params: { taskId: resp.taskId } })
          })
        } else {
          this.clearFilePath()
          this.$notify({
            group: 'notify',
            type: 'error',
            title: '',
            text: 'Please select a Zip file'
          })
        }
      },

      clearFilePath () {
        const input = this.$refs.fileInput
        input.type = 'text'
        input.type = 'file'
      }
    }
  }
</script>

<style scoped>
    .hidden-container{
        visibility: hidden;
        height: 1px;
    }

    .card {
        height: 345px;
        border: 0;
        background: #f5f5f5;
        box-shadow: 2px 1px 6px 0px #b9b9b9;
        border-radius: 0;
        position:relative;
    }

    .card-body {
        margin-top: 0px;
    }
</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideBulkUpload.vue